export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getArticleCategoryList: function getArticleCategoryList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article_type/get",
        method: "get",
        params: data
      });
    },
    addArticleCategory: function addArticleCategory() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article_type/create",
        method: "post",
        data: data
      });
    },
    updateArticleCategory: function updateArticleCategory() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article_type/update",
        method: "post",
        data: data
      });
    },
    deleteArticleCategory: function deleteArticleCategory() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article_type/delete",
        method: "post",
        data: data
      });
    }
  };
});